import React, { useState, useEffect } from "react";
import { Tab, Nav, Container, Row, Col, Button, Form } from "react-bootstrap";
import AlertsGroup from "client_config/AlertsGroup";
import ManageSubsByClient from "alert_subscriptions/ManageSubsByClient";
import OnboardingAlertsGroup from "onboarding/AlertsGroup";
const addUser = (email, sectionName, sectionId) => {
  let returnedData = "";
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/subscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: (data) => {
        returnedData = data;
      },
    });
  }
  return returnedData;
};

const removeUser = (email, sectionName, sectionId) => {
  let removalSuccessful = false;
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/unsubscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: () => {
        removalSuccessful = true;
      },
    });
  }
  return removalSuccessful;
};

export default function Alerts(props) {
  const platforms = [
    {
      platformName: "Google Ads",
      alerts: [
        {
          name: "google_ads_search_impressions_emergency_detector",
          title: "Impressions emergency detector",
          desc: "Gets the number of Google Ads impressions on search & shopping campaigns for each account and if it falls beneath a certain threshold, emails all DP employees.",
        },

        {
          name: "google_ads_search_disapproved_ads_detector",
          title: "Disapproved ads detector",
          desc: "Creates an alert with a list of all disapproved search ads on Google Ads.",
        },
        {
          name: "google_ads_search_out_of_stock_detector",
          title: "Out of stock detector",
          desc: "Checks the landing pages of all search ads on accounts for specific 'out of stock' related language and creates a list of landing pages that match.",
        },
        {
          name: "google_ads_search_impressions_flux_detector",
          title: "Impressions flux detector",
          desc: "Creates an alert if Google Ads search impressions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_search_clicks_flux_detector",
          title: "Clicks flux detector",
          desc: "Creates an alert if Google Ads search clicks fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_search_keyword_bleeder_detector",
          title: "Keyword bleeder detector",
          desc: "Emails the PPC team if a Google Ads keyword has spent over $350 with no conversions in the past 14 days.",
          options: [
            {
              name: "threshold",
              title: "Spend threshold:",
              placeholder: "Default $350",
            },
          ],
        },
        {
          name: "google_ads_search_url_issue_detector",
          title: "URL issue detector",
          desc: "Goes through all Google Ads search ads in an account and makes an alert of pages that produce unacceptable response codes.",
        },

        {
          name: "google_ads_search_spend_flux_detector",
          title: "Spend flux detector",
          desc: "Creates an alert if Google Ads search spend fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },

        {
          name: "google_ads_search_conversions_flux_detector",
          title: "Conversions flux detector",
          desc: "Creates an alert if Google Ads search conversions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_search_conversion_rate_flux_detector",
          title: "Conversion Rate flux detector",
          desc: "Creates an alert if Google Ads search conversion rate fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_search_new_invite_detector",
          title: "New Invite Detector",
          desc: "Creates an alert & sends an email if a new user has been invited to a Google Ads account.",
        },
      ],
    },
    {
      platformName: "Google Shopping",
      alerts: [
        {
          name: "google_ads_shopping_campaign_fluctuation_detector",
          title: "Shopping campaign fluctuation detector",
          desc: "Checks all clicks from all Shopping campaigns on an account and if they fall or rise more than 40%, it will be highlighted in an alert.",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 60%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 140%",
            },
          ],
        },
        {
          name: "google_ads_shopping_product_fluctuation_detector",
          title: "Shopping product fluctuation detector",
          desc: "Checks all products on an account and highlights those which got no clicks despite historically getting clicks in an alert.",
        },
      ],
    },
    {
      platformName: "Microsoft Ads",
      alerts: [
        {
          name: "bing_ads_search_impressions_emergency_detector",
          title: "Impressions emergency detector",
          desc: "Gets the number of Bing Ads impressions on search & shopping campaigns for each account and if it falls beneath a certain threshold, emails all DP employees.",
        },
        {
          name: "bing_ads_search_disapproved_ads_detector",
          title: "Disapproved ads detector",
          desc: "Creates an alert with a list of all disapproved search ads on Bing Ads.",
        },
        {
          name: "bing_ads_search_impressions_flux_detector",
          title: "Impressions flux detector",
          desc: "Creates an alert if Bing Ads search impressions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "bing_ads_search_clicks_flux_detector",
          title: "Clicks flux detector",
          desc: "Creates an alert if Bing Ads search clicks fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "bing_ads_search_keyword_bleeder_detector",
          title: "Keyword bleeder detector",
          desc: "Emails the PPC team if a Bing Ads keyword has spent over $350 with no conversions in the past 14 days.",
          options: [
            {
              name: "threshold",
              title: "Spend threshold:",
              placeholder: "Default $350",
            },
          ],
        },
        {
          name: "bing_ads_search_spend_flux_detector",
          title: "Spend flux detector",
          desc: "Creates an alert if Bing Ads search spend fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "bing_ads_search_conversions_flux_detector",
          title: "Conversions flux detector",
          desc: "Creates an alert if Bing Ads search conversions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "bing_ads_search_conversion_rate_flux_detector",
          title: "Conversion Rate flux detector",
          desc: "Creates an alert if Bing Ads search conversion rate fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Container style={{ backgroundColor: props.onboarding ? "#f5f5f5" : undefined }} fluid className="p-3">
        <Row>
         <Col className="">
            <div className="pt-4 pb-2">
              <p className="text-info f18 visby-bold">Alerts:</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="pr-0 pr-md-5 pl-0 pl-md-4" xl={8}>
            <div className="pb-4 px-3">
              {platforms.map((platform) => {
                return props.onboarding ? (
                  <OnboardingAlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="search"
                    scripts={props.searchScripts}
                    scriptVariables={props.searchScriptsVar}
                    setScripts={props.setSearchScripts}
                    setScriptsVar={props.setSearchScriptsVar}
                    onboarding
                  />
                ) : (
                  <AlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="search"
                    scripts={props.search_section.scripts}
                    scriptVariables={props.search_section.script_variables}
                  />
                );
              })}
            </div>
          </Col>
          <Col xl={4}>
            <div
              className="subs-by-client pt-4 mb-4 px-3"
              style={{
                backgroundColor: "#e1e1e1",
                paddingBottom: "150px"
              }}>
              <h5>Subscribed to these alerts:</h5>
              <ManageSubsByClient
                users={props.users}
                addUser={addUser}
                removeUser={removeUser}
                subscribed_users={props.subs.search_subs}
                section_id={props.subs.search_section_id}
                section_name="SearchSection"
                client_name={props.company_name}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
